// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "2c1b69398c6a3b7543a8" + ".chunk.js";
};